// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slick-slide.slick-active div[data-v-9648b252]{height:447px}@media (max-width:1400px){.padding-left[data-v-9648b252]{padding-left:44px}}@media (max-width:1280px){.padding-left[data-v-9648b252]{padding-left:20px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
